/* CASE HABIT phone-device model catalogue. Display choices; Shopify variants can be linked later. */
(() => {
  "use strict";
  const MODELS = {
  "Apple": {
    "Latest iPhone": [
      "iPhone 18 Pro Max",
      "iPhone 18 Pro",
      "iPhone Duo",
      "iPhone Air",
      "iPhone 17 Pro Max",
      "iPhone 17 Pro",
      "iPhone 17",
      "iPhone 17e",
      "iPhone 16 Pro Max",
      "iPhone 16 Pro",
      "iPhone 16 Plus",
      "iPhone 16",
      "iPhone 16e"
    ],
    "iPhone 15 / 14": [
      "iPhone 15 Pro Max",
      "iPhone 15 Pro",
      "iPhone 15 Plus",
      "iPhone 15",
      "iPhone 14 Pro Max",
      "iPhone 14 Pro",
      "iPhone 14 Plus",
      "iPhone 14"
    ],
    "iPhone 13 / 12": [
      "iPhone 13 Pro Max",
      "iPhone 13 Pro",
      "iPhone 13",
      "iPhone 13 mini",
      "iPhone 12 Pro Max",
      "iPhone 12 Pro",
      "iPhone 12",
      "iPhone 12 mini"
    ],
    "Older iPhone": [
      "iPhone 11 Pro Max",
      "iPhone 11 Pro",
      "iPhone 11",
      "iPhone XS Max",
      "iPhone XS",
      "iPhone XR",
      "iPhone X",
    ]
  },
  "Samsung": {
    "Galaxy S26 / S25": [
      "Galaxy S26 Ultra",
      "Galaxy S26+",
      "Galaxy S26",
      "Galaxy S26 FE",
      "Galaxy S25 Ultra",
      "Galaxy S25+",
      "Galaxy S25",
      "Galaxy S25 Edge",
      "Galaxy S25 FE"
    ],
    "Galaxy S24 / S23": [
      "Galaxy S24 Ultra",
      "Galaxy S24+",
      "Galaxy S24",
      "Galaxy S24 FE",
      "Galaxy S23 Ultra",
      "Galaxy S23+",
      "Galaxy S23",
      "Galaxy S23 FE"
    ],
    "Galaxy S22 / S21 / S20": [
      "Galaxy S22 Ultra",
      "Galaxy S22+",
      "Galaxy S22",
      "Galaxy S21 Ultra",
      "Galaxy S21+",
      "Galaxy S21",
      "Galaxy S21 FE",
      "Galaxy S20 Ultra",
      "Galaxy S20+",
      "Galaxy S20",
      "Galaxy S20 FE"
    ],
    "Older Galaxy S": [
      "Galaxy S10+",
      "Galaxy S10",
      "Galaxy S10e",
      "Galaxy S10 Lite",
      "Galaxy S9+",
      "Galaxy S9",
      "Galaxy S8+",
      "Galaxy S8"
    ],
    "Galaxy A - recent": [
      "Galaxy A57 5G",
      "Galaxy A37 5G",
      "Galaxy A56 5G",
      "Galaxy A36 5G",
      "Galaxy A26 5G",
      "Galaxy A17 5G",
      "Galaxy A16 5G",
      "Galaxy A16",
      "Galaxy A15 5G",
      "Galaxy A15",
      "Galaxy A07",
      "Galaxy A06",
      "Galaxy A06 5G"
    ],
    "Galaxy A - 50 / 70 / 90": [
      "Galaxy A55 5G",
      "Galaxy A54 5G",
      "Galaxy A53 5G",
      "Galaxy A52s 5G",
      "Galaxy A52 5G",
      "Galaxy A52",
      "Galaxy A51",
      "Galaxy A50",
      "Galaxy A73 5G",
      "Galaxy A72",
      "Galaxy A71",
      "Galaxy A70",
      "Galaxy A80",
      "Galaxy A90 5G"
    ],
    "Galaxy A - 20 / 30 / 40": [
      "Galaxy A35 5G",
      "Galaxy A34 5G",
      "Galaxy A33 5G",
      "Galaxy A32 5G",
      "Galaxy A32",
      "Galaxy A31",
      "Galaxy A30",
      "Galaxy A30s",
      "Galaxy A25 5G",
      "Galaxy A24",
      "Galaxy A23 5G",
      "Galaxy A23",
      "Galaxy A22 5G",
      "Galaxy A22",
      "Galaxy A21s",
      "Galaxy A20",
      "Galaxy A20e",
      "Galaxy A14 5G",
      "Galaxy A14",
      "Galaxy A13 5G",
      "Galaxy A13",
      "Galaxy A12",
      "Galaxy A11",
      "Galaxy A10",
      "Galaxy A05s",
      "Galaxy A05",
      "Galaxy A04s",
      "Galaxy A04"
    ],
    "Galaxy Z Fold / Flip": [
      "Galaxy Z Fold8",
      "Galaxy Z Fold7",
      "Galaxy Z Fold6",
      "Galaxy Z Fold5",
      "Galaxy Z Fold4",
      "Galaxy Z Fold3",
      "Galaxy Z Fold2",
      "Galaxy Fold",
      "Galaxy Z Flip8",
      "Galaxy Z Flip7",
      "Galaxy Z Flip7 FE",
      "Galaxy Z Flip6",
      "Galaxy Z Flip5",
      "Galaxy Z Flip4",
      "Galaxy Z Flip3",
      "Galaxy Z Flip 5G",
      "Galaxy Z Flip"
    ],
    "Galaxy Note": [
      "Galaxy Note20 Ultra",
      "Galaxy Note20",
      "Galaxy Note10+",
      "Galaxy Note10",
      "Galaxy Note10 Lite",
      "Galaxy Note9",
      "Galaxy Note8",
      "Galaxy Note FE"
    ],
    "Galaxy M": [
      "Galaxy M55 5G",
      "Galaxy M54 5G",
      "Galaxy M53 5G",
      "Galaxy M52 5G",
      "Galaxy M51",
      "Galaxy M35 5G",
      "Galaxy M34 5G",
      "Galaxy M33 5G",
      "Galaxy M32",
      "Galaxy M23 5G",
      "Galaxy M22",
      "Galaxy M21",
      "Galaxy M15 5G",
      "Galaxy M14 5G",
      "Galaxy M13",
      "Galaxy M12",
      "Galaxy M11"
    ]
  }
};

  function install(scope) {
    const root = scope || document;
    root.querySelectorAll("[data-case-habit-device-selector]").forEach((picker) => {
      if (picker.dataset.chDeviceReady === "1") return;
      const brand = picker.querySelector(".ch-device-picker__brand");
      const model = picker.querySelector(".ch-device-picker__model");
      if (!brand || !model) return;
      picker.dataset.chDeviceReady = "1";

      function refreshModels() {
        const groups = MODELS[brand.value];
        const placeholder = new Option("Choose model", "", true, true);
        placeholder.disabled = true;
        model.replaceChildren(placeholder);
        if (!groups) {
          model.disabled = true;
          return;
        }
        for (const [heading, items] of Object.entries(groups)) {
          const optgroup = document.createElement("optgroup");
          optgroup.label = heading;
          for (const label of items) {
            optgroup.appendChild(new Option(label, label));
          }
          model.appendChild(optgroup);
        }
        model.disabled = false;
        model.value = "";
      }
      brand.addEventListener("change", refreshModels);
      refreshModels();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => install(document), {once:true});
  } else {
    install(document);
  }
  document.addEventListener("shopify:section:load", (event) => install(event.target));
})();
